<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Boletos</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-driver/stops" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="gray" *ngIf="stop">
    <div class="results-header">
      <p>{{stop?.name}}</p>
    </div>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment mode="md" [(ngModel)]="show">
      <ion-segment-button value="bustickets">
        <ion-label>Compra/canje</ion-label>
      </ion-segment-button>
      <ion-segment-button value="subscriptions">
        <ion-label>Suscripción</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-grid *ngIf="show==='bustickets'">
    <ion-row class="header">
      <ion-col size="auto">
        <div>Matrícula</div>
      </ion-col>
      <ion-col>
        <div>Nombre</div>
      </ion-col>
      <ion-col size="auto">
        <div>Boleto</div>
      </ion-col>
      <ion-col size="2">
        <div>Estatus</div>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let item of tickets">
      <ion-col size="auto">
        <div>{{item.user_enrollment}}</div>
      </ion-col>
      <ion-col>
        <div>{{item.user_name}}</div>
      </ion-col>
      <ion-col size="auto">
        <div>T{{("00000" + item.id).slice(-5) }}</div>
      </ion-col>
      <ion-col size="2">
        <div *ngIf="item.status">
          <ion-icon name="checkmark"></ion-icon>
        </div>
        <div *ngIf="!item.status">
          <ion-fab-button size="small" style="margin: 0 auto" (click)="processBusticket(item.id)">
            <ion-icon name="checkmark"></ion-icon>
          </ion-fab-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid *ngIf="show==='subscriptions'">
    <ion-row class="header">
      <ion-col size="auto">
        <div>Matrícula</div>
      </ion-col>
      <ion-col>
        <div>Nombre</div>
      </ion-col>
      <ion-col size="auto">
        <div>Boleto</div>
      </ion-col>
      <ion-col size="2">
        <div>Estatus</div>
      </ion-col>
    </ion-row>
    <ion-row *ngFor="let item of suscribers">
      <ion-col size="auto">
        <div>{{item.user_enrollment}}</div>
      </ion-col>
      <ion-col>
        <div>{{item.user_name}}</div>
      </ion-col>
      <ion-col size="auto">
        <div>S{{("00000" + item.id).slice(-5) }}</div>
      </ion-col>
      <ion-col size="2">
        <div *ngIf="item.status">
          <ion-icon name="checkmark"></ion-icon>
        </div>
        <div *ngIf="!item.status">
          <ion-fab-button size="small" style="margin: 0 auto" (click)="processSubscription(item.id)">
            <ion-icon name="checkmark"></ion-icon>
          </ion-fab-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
